export default {
  pageTitle: 'Fabrikasi Peralatan Lainnya',
  metaDescription: 'TEF memfabrikasi screw conveyor, agitator, impeller, dan peralatan industri khusus lainnya berbahan duplex stainless steel dan alloy eksotis.',
  sidebar: {
    title: 'Daftar Fabrikasi',
    vessel: 'Fabrikasi Vessel',
    heatExchanger: 'Fabrikasi Heat Exchanger',
    piping: 'Fabrikasi Piping',
    tower: 'Fabrikasi Tower',
    muffle: 'Fabrikasi Muffle',
    radiantTube: 'Fabrikasi Radiant Tube',
    otherEquipment: 'Fabrikasi Other Equipment',
  },
  fabricationOf: 'Fabrikasi',
  product: {
    name: 'Other Equipment',
    desc: 'Berikut adalah katalog pengalaman kami dalam fabrikasi Other Equipment dengan berbagai jenis material, tipe, dan spesifikasi.',
  },
};
